type ExtractorFunction = (data: any) => Record<string, any>;

const EXTRACTORS: Record<string, ExtractorFunction> = {
  document: (data) => ({
    contentName: data.contentName,
    contentType: data.extension,
    contentUrl: data.contentUrl || ''
  }),
  
  video: (data) => ({
    contentName: data.contentName,
    contentType: data.extension,
    contentUrl: data.contentUrl || '',
    duration: data.duration
  }),
  
  course: (data) => ({
    courseId: data.id,
    courseName: data.title,
    courseProgress: data.progress,
    courseStatus: data.status
  }),
  
  user: (data) => ({
    userId: data.id,
    userName: data.name,
    userEmail: data.email,
    userRole: data.role
  }),
  
  announcement: (data) => ({
    announcementId: data.id,
    title: data.title,
    priority: data.priority,
    category: data.category
  }),
  
  session: (data) => ({
    sessionId: data.id,
    sessionName: data.title,
    sessionDate: data.date,
    instructor: data.instructor
  }),
  
  raw: (data) => data || {}
};

export const extractData = (data: any, extractorType: string = 'raw'): Record<string, any> => {
  const extractor = EXTRACTORS[extractorType];
  if (!extractor) {
    console.warn(`Extractor '${extractorType}' not found, using raw data`);
    return EXTRACTORS.raw(data);
  }
  return extractor(data);
};